/**
 * newsletterSignupService — public mailing-list signup (double opt-in).
 *
 * Posts an email to the public /api/newsletter/subscribe endpoint, which stores
 * an unconfirmed subscriber and emails a confirmation link. The server returns a
 * generic success for any valid email (it never reveals whether the address is
 * already on file), so the UI just shows "check your email" on success.
 */

import { apiFetchJson } from './apiClient';

export async function subscribeToNewsletter(
  email: string,
  opts: { ownerUserId?: number; orgSlug?: string } = {},
): Promise<{ success: boolean; error?: string }> {
  try {
    // Go through apiClient so the request carries the CSRF header and shares the
    // standard error contract.
    // Target selection (both optional): orgSlug routes to that org's storefront
    // list (/g/:orgSlug/newsletter); ownerUserId is the legacy per-creator path;
    // omitting both = the global platform newsletter (Sleepy Circuits / master org).
    const body: { email: string; ownerUserId?: number; orgSlug?: string } = { email };
    if (opts.ownerUserId != null) body.ownerUserId = opts.ownerUserId;
    if (opts.orgSlug) body.orgSlug = opts.orgSlug;
    const data = await apiFetchJson<{ success?: boolean; error?: string }>(
      '/api/newsletter/subscribe',
      { method: 'POST', body: JSON.stringify(body) },
    );
    return { success: !!data.success, error: data.error };
  } catch (error) {
    console.error('Newsletter subscribe error:', error);
    // apiFetchJson throws Error(serverMessage) on non-2xx; surface it to the UI.
    const message = error instanceof Error ? error.message : '';
    return {
      success: false,
      error: message || 'Network error — please check your connection and try again.',
    };
  }
}
